import styled from "style/styled-components";

const HorizontalScroll = styled.div<{ minHeight?: number }>`
  overflow-x: auto;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 0)};
`;

export default HorizontalScroll;
